"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosErrorInterceptor = void 0;
const domain_1 = require("../../../domain");
class AxiosErrorInterceptor {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
        this.resultStrategies = new Map([
            [domain_1.RootServices.DEFAULT, new domain_1.DefaultResultStrategy()],
            [domain_1.RootServices.APISERVER, new domain_1.ServerApiResultStrategy()],
            [domain_1.RootServices.BUYERAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.KUNAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.LIGHTHOUSEAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.GDTCAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.SELLERAPI, new domain_1.SellerApiResultStrategy()],
            [domain_1.RootServices.WECOM_MSG, new domain_1.WecomMsgResultStrategy()],
            [domain_1.RootServices.CCAPI, new domain_1.CCApiResultStrategy()],
            [domain_1.RootServices.OPENAPI, new domain_1.OpenApiResultStrategy()],
            [domain_1.RootServices.USERAPI, new domain_1.UserApiResultStrategy()],
            [domain_1.RootServices.PAYGW, new domain_1.PaygwResultStrategy()],
        ]);
    }
    setupInterceptor() {
        this.addRequestInterceptor();
        this.addResponseInterceptor();
    }
    errorHandler(...error) {
        return Promise.reject(new domain_1.EndpointError(...error));
    }
    addRequestInterceptor() {
        this.axiosInstance.registerRequestInterceptor(undefined, (error) => {
            console.warn('%c If you need to deal with it, please contact Zan.', 'color: yellow; font-size: 20px;');
            return Promise.reject(error);
        });
    }
    addResponseInterceptor() {
        this.axiosInstance.registerResponseInterceptor(undefined, (error) => {
            var _a, _b;
            if (error.code === 'ERR_CANCELED') {
                return this.errorHandler(error.message, error.code, error.config);
            }
            if (!error.response) {
                error.response = {
                    status: ((_a = error.request) === null || _a === void 0 ? void 0 : _a.status) || -1,
                };
            }
            // FIXME: Subsequent compatibility scope data
            // error.config.microScope
            const errorDup = domain_1.ResponseFactory.createResponse(error.response, this.resultStrategies.get(((_b = error.config) === null || _b === void 0 ? void 0 : _b.rootService) || domain_1.RootServices.DEFAULT));
            return this.errorHandler(errorDup.data.message, errorDup.data.code, errorDup.config || error.config);
        });
    }
}
exports.AxiosErrorInterceptor = AxiosErrorInterceptor;
//# sourceMappingURL=AxiosErrorInterceptor.js.map